export default "__VITE_ASSET__nC_SdCn6__"